import { createEl } from '../lib/dom';
import { SITE } from '../site/site-config';

function svgNs(tag: string, attrs: Record<string, string>): SVGElement {
  const el = document.createElementNS('http://www.w3.org/2000/svg', tag);
  for (const [k, v] of Object.entries(attrs)) {
    el.setAttribute(k, v);
  }
  return el;
}

function appendSvg(parent: SVGElement, ...nodes: Array<SVGElement | string>): void {
  for (const n of nodes) {
    parent.appendChild(typeof n === 'string' ? document.createTextNode(n) : n);
  }
}

/**
 * Silueta simplificada de Latinoamérica + pulsos y gradiente animado por CSS.
 */
function buildColombiaGraphic(): SVGElement {
  const svg = svgNs('svg', {
    class: 'sv-colombia-svg',
    viewBox: '0 0 160 210',
    role: 'img',
    'aria-label': 'Ilustración: cobertura en Latinoamérica',
    focusable: 'false',
  });

  const defs = svgNs('defs', {});
  const grad = svgNs('linearGradient', {
    id: 'sv-colombia-fill',
    x1: '0%',
    y1: '0%',
    x2: '100%',
    y2: '100%',
  });
  appendSvg(
    grad,
    svgNs('stop', { offset: '0%', 'stop-color': '#9c4dcc', 'stop-opacity': '1' }),
    svgNs('stop', { offset: '55%', 'stop-color': '#6a1b9a', 'stop-opacity': '1' }),
    svgNs('stop', { offset: '100%', 'stop-color': '#4a148c', 'stop-opacity': '1' })
  );
  appendSvg(defs, grad);

  const rings = svgNs('g', { class: 'sv-colombia-rings' });
  for (let i = 0; i < 3; i += 1) {
    const c = svgNs('circle', {
      class: `sv-colombia-ring sv-colombia-ring--${i}`,
      cx: '88',
      cy: '108',
      r: String(36 + i * 16),
    });
    rings.appendChild(c);
  }

  const path = svgNs('path', {
    class: 'sv-colombia-outline',
    fill: 'url(#sv-colombia-fill)',
    d:
      'M42 38 L58 22 L78 18 L92 28 L88 42 L72 52 L68 62 L82 70 L78 82 L98 90 L122 96 L138 112 L142 132 L128 152 L112 178 L98 198 L78 204 L64 190 L58 168 L48 148 L36 128 L28 108 L22 86 L26 64 L34 48 Z',
  });

  const pins = svgNs('g', { class: 'sv-colombia-pins' });
  const pinCoords: Array<[string, string, string]> = [
    ['62', '36', '0'],
    ['72', '68', '1'],
    ['78', '96', '2'],
    ['118', '118', '3'],
    ['88', '168', '4'],
  ];
  for (const [cx, cy, slot] of pinCoords) {
    const g = svgNs('g', { class: `sv-colombia-pin sv-colombia-pin--${slot}` });
    appendSvg(
      g,
      svgNs('circle', { cx, cy, r: '3.5', class: 'sv-colombia-pin__dot' }),
      svgNs('circle', { cx, cy, r: '10', class: 'sv-colombia-pin__ripple' })
    );
    pins.appendChild(g);
  }

  appendSvg(svg, defs, rings, path, pins);
  return svg;
}

export function renderColombia(target: HTMLElement): void {
  const frame = createEl('div', { className: 'sv-colombia-visual__frame' });
  frame.appendChild(buildColombiaGraphic());
  const visual = createEl('div', { className: 'sv-colombia-visual' }, [frame]);

  const section = createEl(
    'section',
    {
      className: 'sv-section sv-section--surface sv-colombia-section',
      id: 'colombia',
      'aria-labelledby': 'colombia-title',
    },
    [
      createEl('div', { className: 'sv-inner sv-colombia-layout' }, [
        createEl('div', { className: 'sv-colombia-copy' }, [
          createEl('p', { className: 'sv-colombia-eyebrow' }, [SITE.colombiaEyebrow]),
          createEl('h2', { className: 'sv-colombia-title', id: 'colombia-title' }, [SITE.colombiaTitle]),
          createEl('p', { className: 'sv-colombia-lead' }, [SITE.colombiaDescription]),
        ]),
        visual,
      ]),
    ]
  );
  target.appendChild(section);
}
